import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Image,
  // Switch,
  Tag,
  TagCloseButton,
  TagLabel,
  Text,
  Tooltip
} from '@chakra-ui/react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css';
import QueueGrid from './elements/QueueGrid';
import Panel from './elements/Panel';
import { AgGridReact } from 'ag-grid-react';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Transfer from '../model/transfer.mjs';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FilterDropDown from '@/explore/ffl-detail/licenseByZipQuery/filters';
import { FilterMode, TransferCurrentNavigation, TransferFilterModel } from './types';
import TransferSearchForm from './elements/TransferSearchForm';
import { callToGetEcommerceStatus, callToRemoveTransferFilters, downloadTransferListForExcel, setEccomerceStatusFilterLists, setIsClearAllFilterClickedOnTransfer, setIsRefreshingTransfers, setIsRemoveAnyFilter, setSelectedSavedTransferFilter, setSkipDefaultTransferQueueFilterAutoApply, setSourceDescriptionLists, setSourceDescriptions, setStoreNameLists, setTransferCurrentNavigation, setTransferFilterModel, StoreNameType, setSellerLicenseKeyLists } from './ducks/slice';
import { useDispatch } from 'react-redux';
import { getIsExportTransferReportButtonDisabled, getTransferCurrentNavigation, getIsLoadingTransferExcelGeneration, getIsRefreshingTransfers, getTransferCount, getTransferQueueLoading, getSourceDescriptionLists, getStoreNameLists, getStoreNamesData, getSourceDescriptions, getEcommerceStatusLists, getEcommerceStatusFilterLists, getSellerLicenseKeyLists } from './ducks/selectors';
import { impersionateUser } from '@/api/apis';
import { DateValue } from 'react-aria';
import { getTransferFilterModel } from '@/explore/ducks/selectors';
import { CalendarDate } from '@internationalized/date';
import { firearmType, transferMacrostatus, transferMacroSubStatusV2, sellerLicenseKeyFilter } from '@/utils/constants';
import * as constants from '@/utils/constants';
import { logAnalyticsEvent } from '@/utils/analyticsLogger';
import { analyticsEvents } from '@/utils/analyticsEvents';
import FlatDatePickr from '@/common/Flatpickr';
import { getIsGlobalOperations, getIsImpersonating } from '@/redux/app-selectors';

export interface CognitoInterface {
  cognitoGroup: boolean;
  isSuperAdmin: boolean;
  isStoreAdmin: boolean;
  isStoreAgent?: boolean;
  isShowOnlyNFAFilterDisabled?: boolean;
  isAssignDealerModal?: boolean;
  assignNewDealerInitialZipCode?: string;
  onCloseAssignDealerModal?(): void;
  transferId?: string;
  assignedDealerLicenseKey?: string;
  type?: string;
  setLicenseKey?: (val: string) => void;
}

export default function Queue({
  cognitoGroup,
  isSuperAdmin,
  isStoreAdmin,
  isStoreAgent,
}: CognitoInterface) {
  const gridRef = useRef<AgGridReact<Transfer>>(null);
  const [isPageNotAllowed, setIsPageNotAllowed] = useState(true);
  const [chipsValue, setChipsValue] = useState<any>([]);
  const [searchParams, setURLSearchParams] = useSearchParams();
  const [transferDateError, setTransferDateError] = useState('');
  const transferFilterModel = getTransferFilterModel();
  const sourceDiscription = getSourceDescriptionLists();
  const eccomerceFilterList = getEcommerceStatusFilterLists();
  const storeNames = getStoreNameLists();
  const dispatch = useDispatch();
  const isRefreshingTransfers = getIsRefreshingTransfers();
  const isLoadingTransferExcelGeneration = getIsLoadingTransferExcelGeneration();
  const isExportTransferReportButtonDisabled = getIsExportTransferReportButtonDisabled();
  const transferCurrentNavigation = getTransferCurrentNavigation();
  const totalResults = getTransferCount();
  const transferQueueLoading = getTransferQueueLoading();
  // const [isOutbound, setIsOutbound] = useState(true);
  const navigate = useNavigate();
  const isGlobalOperations = getIsGlobalOperations();
  const isImpersonating = getIsImpersonating();
  // const savedUserPermissions = JSON.parse(localStorage.getItem('savedUserPermissions') || '{}');
  // const savedIsOutbound = localStorage.getItem('savedIsOutbound') || '';
  // const isImpersonating = getIsImpersonating();

  // useEffect(() => {
  //   // Only check permissions for agents and admins
  //   if ((isStoreAgent || isStoreAdmin) && !isImpersonating) {
  //     if (savedUserPermissions?.transfer?.length > 0 &&
  //         savedUserPermissions?.transfer?.includes('inbound') &&
  //         savedUserPermissions?.transfer?.includes('outbound')) {
  //       if(savedIsOutbound === ''){
  //         localStorage.setItem('savedIsOutbound', 'true');
  //       }
  //     } else if (savedUserPermissions?.transfer?.length > 0 &&
  //                savedUserPermissions?.transfer?.includes('inbound')) {
  //       localStorage.setItem('savedIsOutbound', 'false');
  //     } else if(savedUserPermissions?.transfer?.length > 0 &&
  //               savedUserPermissions?.transfer?.includes('outbound')){
  //       localStorage.setItem('savedIsOutbound', 'true');
  //     }
  //   }
  //   console.log('savedUserPermissions !!!!', savedUserPermissions);
  //   console.log('isStoreAgent !!!', isStoreAgent, isImpersonating);
  //   console.log('isStoreAdmin !!!', isStoreAdmin, isSuperAdmin);

  // }, [JSON.stringify(savedUserPermissions), isStoreAgent, isStoreAdmin]);

  // useEffect(() => {
  //   if (savedIsOutbound !== null && savedIsOutbound !== '') {
  //     setIsOutbound(savedIsOutbound === 'true');
  //   }
  // }, [savedIsOutbound]);

  useEffect(() => {
    if (window.innerWidth > 743 || window.innerHeight <= 480) {
      setIsPageNotAllowed(false);
    } else {
      navigate('/dealers');
    }
  });

  useEffect(() => {
    if (
      transferFilterModel?.createdAt?.dateFrom &&
      transferFilterModel?.createdAt?.dateTo &&
      new Date(transferFilterModel?.createdAt?.dateFrom) >
      new Date(transferFilterModel?.createdAt?.dateTo)
    ) {
      setTransferDateError(constants.INVALID_RANGE);
    } else {
      if (
        (!transferFilterModel?.createdAt?.dateFrom &&
          !transferFilterModel?.createdAt?.dateTo) ||
        (transferFilterModel?.createdAt?.dateFrom &&
          transferFilterModel?.createdAt?.dateTo)
      ) {
        setTransferDateError('');
      } else {
        setTransferDateError(
          constants.SELECT_FIELD_DATE.replace(
            '{{field}}',
            !transferFilterModel.createdAt.dateFrom ? 'start' : 'end'
          )
        );
      }
    }
  }, [JSON.stringify(transferFilterModel.createdAt)]);

  function getValuesAndTypes(json: TransferFilterModel) {
    const result = [];

    for (const key in json) {
      if (Object.prototype.hasOwnProperty.call(json, key)) {
        const keyValue = key as keyof TransferFilterModel;

        const filter = json[keyValue];

        let value = null;

        if ('values' in filter && filter?.values.length > 0) {
          value = filter.values;
          result.push({ key, value });
        }
      }
    }
    return result;
  }
  const getfilterChips = () => {
    const chips: { [key: string]: string }[] = [];
    let keyName: string | null = null;
    let valueArr: any = [];
    const getFilters = getValuesAndTypes(transferFilterModel);
    for (const [key, filterValue] of Object.entries(getFilters)) {
      keyName = filterValue.key;
      valueArr = filterValue.value;
      if (keyName && valueArr) {
        valueArr.forEach((val: any) => {
          let chipObj: any = { fieldName: keyName, fieldValue: val }
          const filterTypeVal = (keyName === 'derivedStatus' || keyName === 'microStatus') ? transferFilterModel[keyName].filterType : '';
          chipObj = { ...chipObj, filterType: filterTypeVal };
          if (keyName && val !== 'all') chips.push(chipObj);
        });
      }
    }

    return chips
  }
  useEffect(() => {
    if (transferFilterModel) {
      const result = getfilterChips();
      setChipsValue(result)
    }

  }, [transferFilterModel])

  function refreshTransfers() {
    dispatch(setIsRefreshingTransfers(true));
    dispatch(callToGetEcommerceStatus({}));
    gridRef.current?.api.setRowCount(0);
    gridRef.current?.api?.refreshInfiniteCache();
  }
  function downloadReport() {
    dispatch(downloadTransferListForExcel(gridRef))
  }

  function onClickTransferNavigattion(
    transferCurrentNavigation: TransferCurrentNavigation
  ) {
    return () => {
      dispatch(setTransferCurrentNavigation(transferCurrentNavigation));
      if (transferCurrentNavigation === TransferCurrentNavigation.ARCHIVE) {
        let params = {};
        for (let [key, value] of searchParams.entries()) {
          params = { ...params, [key]: value };
        }
        setURLSearchParams({ ...params, archive: 'true' });
      } else {
        searchParams.delete('archive');
        setURLSearchParams(searchParams);
      }
    };
  }

  const getHeaderText = () => {
    if (transferQueueLoading) {
      return 'Searching results...'
    } else if (totalResults > 0) {
      return `Found ${totalResults} results.`
    }
  }

  const resetColumnState = useCallback(() => {
    // Clear the saved column state from localStorage before resetting
    const columnStateKey = (isSuperAdmin || isGlobalOperations) ? 'globalAdminColumnState' : 'adminColumnState';
    const resetFlagKey = `${columnStateKey}_resetting`;

    // Set a flag to prevent QueueGrid from applying saved state during reset
    localStorage.setItem(resetFlagKey, 'true');

    // Clear localStorage first
    localStorage.removeItem(columnStateKey);

    // Reset columns to default state
    // Use a more robust approach that ensures grid is ready, especially after refresh
    const resetColumns = () => {
      if (gridRef.current?.api) {
        try {
          // Reset column state to defaults - this resets visibility, width, order, etc.
          gridRef.current.api.resetColumnState();

          // Immediately clear localStorage again to prevent onColumnStateChanged from saving state
          localStorage.removeItem(columnStateKey);

          // Verify reset worked by checking if all columns are visible
          const allColumns = gridRef.current.api.getColumns();
          if (allColumns) {
            // Columns that should stay hidden when impersonating (global admin/ops only)
            const roleRestrictedColIds = ['sellerDisplayName', 'sellerTimezone', 'lastDealerEvent'];
            const shouldExcludeFromForceShow = (colId: string) =>
              isImpersonating && roleRestrictedColIds.includes(colId);

            // Exclude searchText (always hidden) and role-restricted columns when impersonating
            const hiddenColumns = allColumns.filter(
              col => !col.isVisible() && col.getColId() !== 'searchText' && !shouldExcludeFromForceShow(col.getColId())
            );
            if (hiddenColumns.length > 0) {
              // If some columns are still hidden, explicitly show them (except role-restricted when impersonating)
              hiddenColumns.forEach(col => {
                gridRef.current?.api.setColumnVisible(col, true);
              });
              // Clear localStorage again after forcing visibility
              localStorage.removeItem(columnStateKey);
            }
            // Ensure searchText column remains hidden after reset
            const searchTextColumn = allColumns.find(col => col.getColId() === 'searchText');
            if (searchTextColumn && searchTextColumn.isVisible()) {
              gridRef.current?.api.setColumnVisible(searchTextColumn, false);
            }
          }
        } catch (error) {
          console.error('Error resetting column state:', error);
        }
      }
    };

    // Wait a bit longer after refresh - grid might still be processing
    // Try multiple times with increasing delays to ensure it works
    setTimeout(() => {
      resetColumns();
    }, 300);

    setTimeout(() => {
      resetColumns();
    }, 600);

    setTimeout(() => {
      resetColumns();
    }, 1000);

    // Clear the reset flag and localStorage after reset is complete
    setTimeout(() => {
      localStorage.removeItem(columnStateKey);
      localStorage.removeItem(resetFlagKey);
    }, 1500);
  }, [isSuperAdmin, isGlobalOperations, isImpersonating]);

  enum TransferDateFieldEnum {
    dateFrom = 'dateFrom',
    dateTo = 'dateTo'
  }
  const onChangeTransferDate = (fieldName: TransferDateFieldEnum | null) => {

    return (value: any | null) => {
      if (!value) return;
      if (fieldName) {
        const date = new Date(value);
        if (fieldName === TransferDateFieldEnum.dateFrom) {
          date.setHours(0, 0, 0, 0);
        } else {
          date.setHours(23, 59, 59, 999);
        }
        dispatch(
          setTransferFilterModel({
            ...transferFilterModel,
            createdAt: {
              ...transferFilterModel.createdAt,
              [fieldName]: date.toISOString()
            }
          })
        );
      }
    };
  };
  const onChangeTransferStartDate = onChangeTransferDate(
    TransferDateFieldEnum.dateFrom
  );
  const onChangeTransferEndDate = onChangeTransferDate(
    TransferDateFieldEnum.dateTo
  );

  const findLabelByValue = (dataDetails: StoreNameType[], val: string) => {
    const result = dataDetails.find(data => data.value === val);
    return result ? result.label : null;
  }
  const storeList = getStoreNamesData()
  const sourcesList = getSourceDescriptions();
  const eccomerceStatusList = getEcommerceStatusLists();
  const sellerLicenseKeyLists = getSellerLicenseKeyLists();
  const onRestTransferDate = () => {
    dispatch(
      setTransferFilterModel({
        ...transferFilterModel,
        createdAt: {
          ...transferFilterModel.createdAt,
          dateFrom: null,
          dateTo: null
        }
      })
    );
  };
  const clearAllFilters = () => {
    dispatch(setSkipDefaultTransferQueueFilterAutoApply(true));
    dispatch(setIsClearAllFilterClickedOnTransfer(true))
    dispatch(setSelectedSavedTransferFilter(null));
    // onRestTransferDate();
    dispatch(setTransferFilterModel({
      ...transferFilterModel,
      storeName: { ...transferFilterModel.storeName, values: [] },
      source: { ...transferFilterModel.source, values: [] },
      transferType: { ...transferFilterModel.transferType, values: [] },
      derivedStatus: { ...transferFilterModel.derivedStatus, values: [] },
      microStatus: { ...transferFilterModel.microStatus, values: [] },
      agent: { ...transferFilterModel.agent, values: [] },
      firearm: { ...transferFilterModel.firearm, values: [] },
      isArchive: { ...transferFilterModel.isArchive, values: [] },
      is_external: { ...transferFilterModel.is_external, values: [] },
      createdAt: { ...transferFilterModel.createdAt, dateFrom: null, dateTo: null },
      ecommerce_status: { ...transferFilterModel.ecommerce_status, values: [] },
      sellerLicenseKey: {...transferFilterModel.sellerLicenseKey, values: []}
    }));
    dispatch(setStoreNameLists([]));
    dispatch(setSourceDescriptionLists([]));
    dispatch(setEccomerceStatusFilterLists([]));
    dispatch(setSellerLicenseKeyLists([]));
  }
  const handleRemoveTag = (field: string, value: string) => {
    if (field === 'firearm') {
      const removeFirearmTag = transferFilterModel.firearm.values.filter(item => item !== value)
      dispatch(setTransferFilterModel({
        ...transferFilterModel,
        firearm: { ...transferFilterModel.firearm, values: removeFirearmTag }
      }));
    }
    if (field === 'derivedStatus') {
      const removeIsExternalTag = transferFilterModel.derivedStatus.values.filter(item => item !== value).filter(item => item !== "all" || value === "all");;
      dispatch(setTransferFilterModel({
        ...transferFilterModel,
        derivedStatus: { ...transferFilterModel.derivedStatus, values: removeIsExternalTag },
        microStatus: { ...transferFilterModel.microStatus, values: [] },
      }));
    }
    if (field === 'microStatus') {
      const removeMicroStatusTag = transferFilterModel.microStatus.values.filter(item => {
        if (value === "queue_status_dealer_changed") {
          return item !== value && item !== "dealer_selected";
        }
        return item !== value
      })
      dispatch(setTransferFilterModel({
        ...transferFilterModel,
        microStatus: { ...transferFilterModel.microStatus, values: removeMicroStatusTag }
      }));
    }
    if (field === 'is_external') {
      const removeIsExternalTag = transferFilterModel.is_external.values.filter(item => item !== value)
      dispatch(setTransferFilterModel({
        ...transferFilterModel,
        is_external: { ...transferFilterModel.is_external, values: removeIsExternalTag }
      }));
    }
    if (field === 'agent') {
      const removeAgentTag = transferFilterModel.agent.values.filter(item => item !== value)
      dispatch(setTransferFilterModel({
        ...transferFilterModel,
        agent: { ...transferFilterModel.agent, values: removeAgentTag }
      }));
    }
    if (field === 'isArchive') {
      const removeIsArchiveTag = transferFilterModel.isArchive.values.filter(item => item !== value)
      dispatch(setTransferFilterModel({
        ...transferFilterModel,
        isArchive: { ...transferFilterModel.isArchive, values: removeIsArchiveTag }
      }));
    }
    if (field === 'source') {
      const removeSourceTag = transferFilterModel.source.values.filter(item => item !== value)
      dispatch(
        setTransferFilterModel({
          ...transferFilterModel,
          source: { ...transferFilterModel.source, values: removeSourceTag }
        })
      );
      const sourceTag = sourceDiscription.filter(item => item.value !== value)
      dispatch(setSourceDescriptionLists(sourceTag));
    }
    if (field === 'ecommerce_status') {
      const removeEccomerceTag = transferFilterModel.ecommerce_status.values.filter(item => item !== value)
      dispatch(
        setTransferFilterModel({
          ...transferFilterModel,
          ecommerce_status: { ...transferFilterModel.ecommerce_status, values: removeEccomerceTag }
        })
      );
      const sourceTag = eccomerceFilterList.filter(item => item.value !== value)
      dispatch(setEccomerceStatusFilterLists(sourceTag));
    }
    if (field === 'storeName') {
      const removeStoreNameTag = transferFilterModel.storeName.values.filter(item => item !== value)
      dispatch(
        setTransferFilterModel({
          ...transferFilterModel,
          storeName: { ...transferFilterModel.storeName, values: removeStoreNameTag }
        })
      );
      const storeNameTag = storeNames.filter(item => item.value !== value)
      dispatch(setStoreNameLists(storeNameTag));
    }
    if (field === 'sellerLicenseKey') {
      const removeSellerLicenseKeyTag = ((transferFilterModel.sellerLicenseKey as any)?.values || []).filter((item: any) => item !== value)

      dispatch(
        setTransferFilterModel({
          ...transferFilterModel,
          sellerLicenseKey: {
            ...(transferFilterModel.sellerLicenseKey as any || {}),
            filterType: 'set',
            values: removeSellerLicenseKeyTag
          }
        })
      );

      // Also remove from sellerLicenseKeyLists
      const sellerTag = sellerLicenseKeyLists.filter((item: any) => item.shortLicenseNumber !== value)
      dispatch(setSellerLicenseKeyLists(sellerTag));
    }
    dispatch(setIsRemoveAnyFilter(true))
  }
  const onClickTransferNavigattionFunction = onClickTransferNavigattion(TransferCurrentNavigation.ARCHIVE);

  const clickHandler = () => {
    logAnalyticsEvent(analyticsEvents.archiveList);
    onClickTransferNavigattionFunction();
  }

  const getChipValueForExcludeTransfers = (value: string) => {
    if (value === 'outbound_transfer_complete')
      return 'Exclude Completed'
    else if (value === 'tranfer_pending') return 'Exclude Pending'
    else if (value === 'queue_status_first_time_confirmation_delay') return 'Exclude First Time Confirmation Delay'
  }
  function setDateRange(dateFrom: Date, dateTo: Date) {
    const endDate = new Date(dateTo);
    const startDate = new Date(dateFrom);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    dispatch(
      setTransferFilterModel({
        ...transferFilterModel,
        createdAt: {
          ...transferFilterModel.createdAt,
          dateFrom: startDate.toISOString(),
          dateTo: endDate.toISOString()
        }
      })
    );
  }

  function handleTodayClick() {
    const today = new Date();
    setDateRange(today, today);
    // refreshTransfers();
  }

  function handleThisWeekClick() {
    const today = new Date();
    const firstDayOfWeek = new Date();
    firstDayOfWeek.setDate(today.getDate() - 7);
    setDateRange(firstDayOfWeek, today);
    // refreshTransfers();
  }

  function handleThisMonthClick() {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    setDateRange(firstDayOfMonth, today);
    // refreshTransfers();
  }
  const handleResetDateClick = () => {
    onRestTransferDate();
    refreshTransfers();
  };

  // const handleOutboundSwitchChange = (e: any) => {
  //   console.log('e.target.checked', e.target.checked)
  //   setIsOutbound(e.target.checked)
  //   localStorage.setItem('savedIsOutbound', e.target.checked.toString())
  // }


  return !isPageNotAllowed ? (
    <Box className={'Queue'}>
      {(isStoreAdmin || isStoreAgent) && (
        <Breadcrumb
          style={{ marginBottom: '10px' }}
          className="transfer-navigation"
        >
          <BreadcrumbItem
            className="transfer-navigation__option"
            onClick={onClickTransferNavigattion(
              TransferCurrentNavigation.TRANSFER_QUEUE
            )}
            isCurrentPage={
              transferCurrentNavigation ===
              TransferCurrentNavigation.TRANSFER_QUEUE
            }
          >
            <BreadcrumbLink
              href="javascript:void(0);"
              className="transfer-navigation__link"
            >
              Transfer Queue
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbItem
            onClick={clickHandler}
            className="transfer-navigation__option"
            isCurrentPage={
              transferCurrentNavigation === TransferCurrentNavigation.ARCHIVE
            }
          >
            <BreadcrumbLink
              href="javascript:void(0);"
              className="transfer-navigation__link"
            >
              Archive
            </BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>
      )}

      <Box className="transfer-header-queue" sx={{ marginBottom: '2.5rem', position: 'relative' }}>
        <Box className='flex-column q-search-wrapper' sx={{ minWidth: '333px' }}>
          <TransferSearchForm />
          <Text className='transfer-count-text'>{getHeaderText()}</Text>
        </Box>
        <Box className='flex-column q-date-wrapper' sx={{ position: 'relative', width: '41%', flexGrow: 1 }}>

          <Box className='flex-row'>
            <div className="date-range-wrapper__item_queue">
              <FlatDatePickr label="From Date" onDateChange={onChangeTransferStartDate}
                value={
                  transferFilterModel.createdAt &&
                    transferFilterModel.createdAt.dateFrom &&
                    transferFilterModel.createdAt.dateFrom !== 'null'
                    ? (() => {
                      return new Date(transferFilterModel.createdAt.dateFrom);
                    })()
                    : undefined
                }
              />
            </div>
            <div className="date-range-wrapper__item_queue">
              <FlatDatePickr label="To Date" onDateChange={onChangeTransferEndDate}
                value={
                  transferFilterModel.createdAt &&
                    transferFilterModel.createdAt.dateTo &&
                    transferFilterModel.createdAt.dateTo !== 'null'
                    ? new Date(transferFilterModel.createdAt.dateTo)
                    : undefined
                }
              />
            </div>
            <Box className='flex-row'>
              <Button
                className="refresh-btn-queue"
                onClick={handleTodayClick}
              >
                Today
              </Button>
              <Button
                className="refresh-btn-queue"
                onClick={handleThisWeekClick}
              >
                This Week
              </Button>
              <Button
                className="refresh-btn-queue"
                onClick={handleThisMonthClick}
              >
                This Month
              </Button>
              {transferFilterModel.createdAt &&
                transferFilterModel.createdAt.dateTo &&
                transferFilterModel.createdAt.dateTo !== 'null' &&
                transferFilterModel.createdAt &&
                transferFilterModel.createdAt.dateFrom &&
                transferFilterModel.createdAt.dateFrom !== 'null'
                && (
                  <Button
                    className="refresh-btn-queue"
                    onClick={handleResetDateClick}
                  >
                    Reset
                  </Button>
                )}
            </Box>
          </Box>
          <div className='date-range-error'>
            <span className="transfer-filter-error">{transferDateError}</span>
          </div>
        </Box>
        <Box className="transfer-header__right" sx={{ alignItems: 'center', margin: 0 }}>
          {/* {((((isStoreAgent || isStoreAdmin) && !isImpersonating) &&
            savedUserPermissions?.transfer?.length > 0 &&
            savedUserPermissions?.transfer?.includes('inbound') &&
            savedUserPermissions?.transfer?.includes('outbound')) ||
            ((!isStoreAgent && !isStoreAdmin) || isImpersonating)) && (
              <Box className='flex-row' sx={{ alignItems: 'center', marginRight: '20px' }}>
                <Text>Inbound</Text>
                <Switch
                  sx={{ background: '#0C1E46', borderRadius: '9999px' }}
                  isChecked={isOutbound}
                  onChange={handleOutboundSwitchChange}
                />
                <Text>Outbound</Text>
              </Box>
            )} */}
          <Box className='reset-column'>
            <Button className='reset-btn-queue' onClick={resetColumnState}>Reset Columns</Button>
          </Box>
          {/* <Tooltip
            hasArrow
            placement="top"
            label="Export transfer list"
            color={'black'}
            bg={'white'}
          >
            <Box className="transfer-report" onClick={downloadReport}>
              <Button className="transfer-report-button" isLoading={isLoadingTransferExcelGeneration} loadingText={"Exporting"} isDisabled={isExportTransferReportButtonDisabled}>
                Export as Excel
              </Button>
            </Box>
          </Tooltip> */}
          <Tooltip
            hasArrow
            placement="top"
            label="Refresh"
            color={'black'}
            bg={'white'}
          >
            <Button
              isLoading={isRefreshingTransfers}
              spinner={
                <img
                  className="refresh-btn__spinner"
                  src="/images/ui/refresh.svg"
                />
              }
              className="refresh-btn-queue"
              onClick={refreshTransfers}
            >
              <img src="/images/ui/refresh.svg" />
            </Button>
          </Tooltip>
          <Box className="transfer-filters">
            <FilterDropDown
              isFiltersDisabled={false}
              filterMode={FilterMode.TRANSFER_FILTER}
              // isInbound={!isOutbound}
              isInbound={true}
            />
          </Box>
        </Box>
      </Box>
      <Box className='outer-clips-box'>
        <Box className='left-inner-clips-box'>
          {chipsValue.length > 0 && chipsValue.map((chip: any, index: any) => {
            if (chip?.fieldName === 'firearm') {
              const fieldValue = chip.fieldValue as keyof typeof firearmType;
              return <Tag key={index} className='chip-box'>
                <TagLabel className='tag-label'>{firearmType[fieldValue]}</TagLabel>
                <TagCloseButton
                  padding={'0px'}
                  fontSize={'15px'}
                  color={'#436175'}
                  onClick={() => handleRemoveTag(chip?.fieldName, chip.fieldValue)}
                />
              </Tag>
            }
            if (chip?.fieldName === 'ecommerce_status')
              return <Tag key={index} className='chip-box'>
                <TagLabel className='tag-label'>{findLabelByValue(eccomerceStatusList, chip.fieldValue)}</TagLabel>
                <TagCloseButton
                  padding={'0px'}
                  fontSize={'15px'}
                  color={'#436175'}
                  onClick={() => handleRemoveTag(chip?.fieldName, chip.fieldValue)}
                />
              </Tag>
               if (chip?.fieldName === 'sellerLicenseKey') {

                const fieldValue = chip.fieldValue as string;
                const filterLabel = sellerLicenseKeyFilter[fieldValue as keyof typeof sellerLicenseKeyFilter]
                  ?? constants.transferTypeFilter[fieldValue as keyof typeof constants.transferTypeFilter];
                if (filterLabel) {
                  return <Tag key={index} className='chip-box'>
                    <TagLabel className='tag-label'>{filterLabel}</TagLabel>
                    <TagCloseButton
                      padding={'0px'}
                      fontSize={'15px'}
                      color={'#436175'}
                      onClick={() => handleRemoveTag(chip?.fieldName, chip.fieldValue)}
                    />
                  </Tag>;
                }
              }
            if (chip?.fieldName === 'source')
              return <Tag key={index} className='chip-box'>
                <TagLabel className='tag-label'>{findLabelByValue(sourcesList, chip.fieldValue)}</TagLabel>
                <TagCloseButton
                  padding={'0px'}
                  fontSize={'15px'}
                  color={'#436175'}
                  onClick={() => handleRemoveTag(chip?.fieldName, chip.fieldValue)}
                />
              </Tag>
            if (chip?.fieldName === 'storeName')
              return <Tag key={index} className='chip-box'>
                <TagLabel className='tag-label'>{findLabelByValue(storeList, chip.fieldValue)}</TagLabel>
                <TagCloseButton
                  padding={'0px'}
                  fontSize={'15px'}
                  color={'#436175'}
                  onClick={() => handleRemoveTag(chip?.fieldName, chip.fieldValue)}
                />
              </Tag>
            if (chip?.fieldName === 'agent')
              return <Tag key={index} className='chip-box'>
                <TagLabel className='tag-label'>{chip.fieldValue}</TagLabel>
                <TagCloseButton
                  padding={'0px'}
                  fontSize={'15px'}
                  color={'#436175'}
                  onClick={() => handleRemoveTag(chip?.fieldName, chip.fieldValue)}
                />
              </Tag>
            if (chip?.fieldName === 'is_external')
              return <Tag key={index} className='chip-box'>
                <TagLabel className='tag-label'>{chip.fieldValue === 'true' ? 'Live' : 'Testing'}</TagLabel>
                <TagCloseButton
                  padding={'0px'}
                  fontSize={'15px'}
                  color={'#436175'}
                  onClick={() => handleRemoveTag(chip?.fieldName, chip.fieldValue)}
                />
              </Tag>
            if (chip?.fieldName === 'isArchive')
              return <Tag key={index} className='chip-box'>
                <TagLabel className='tag-label'>{chip.fieldValue === 'true' && 'Include Archived'}</TagLabel>
                <TagCloseButton
                  padding={'0px'}
                  fontSize={'15px'}
                  color={'#436175'}
                  onClick={() => handleRemoveTag(chip?.fieldName, chip.fieldValue)}
                />
              </Tag>
            if (chip?.fieldName === 'sellerLicenseKey') {
              
              // Find the seller by shortLicenseNumber to get licenseName
              const seller = sellerLicenseKeyLists.find((s: any) => s.shortLicenseNumber === chip.fieldValue);
              const displayName = seller?.businessName || chip.fieldValue;
              return <Tag key={index} className='chip-box'>
                <TagLabel className='tag-label'>{displayName.toUpperCase()}</TagLabel>
                <TagCloseButton
                  padding={'0px'}
                  fontSize={'15px'}
                  color={'#436175'}
                  onClick={() => handleRemoveTag(chip?.fieldName, chip.fieldValue)}
                />
              </Tag>
            }
            if (chip?.fieldName === 'derivedStatus' && chip?.fieldValue !== 'all')
              return <Tag key={index} className='chip-box'>
                {chip.filterType === 'notEqual' ? (
                  <TagLabel className='tag-label'>{getChipValueForExcludeTransfers(chip?.fieldValue)}</TagLabel>
                ) : (
                  <TagLabel className='tag-label'>{transferMacrostatus[chip.fieldValue]}</TagLabel>
                )}
                <TagCloseButton
                  padding={'0px'}
                  fontSize={'15px'}
                  color={'#436175'}
                  onClick={() => handleRemoveTag(chip?.fieldName, chip.fieldValue)}
                />
              </Tag>
            if (chip?.fieldName === 'microStatus' && chip?.fieldValue !== 'dealer_selected')
              return <Tag key={index} className='chip-box'>
                {chip.filterType === 'notEqual' ? (
                  <TagLabel className='tag-label'>{getChipValueForExcludeTransfers(chip?.fieldValue)}</TagLabel>
                ) : (
                  <TagLabel className='tag-label'>{
                    transferMacroSubStatusV2.transfer_initiated[chip.fieldValue]
                    || transferMacroSubStatusV2.initiation_email_sent[chip.fieldValue]
                    || transferMacroSubStatusV2.waiting_dealer_action[chip.fieldValue]
                    || transferMacroSubStatusV2.waiting_license_validation[chip.fieldValue]
                    || transferMacroSubStatusV2.outbound_transfer_complete[chip.fieldValue]
                  }</TagLabel>
                )}
                <TagCloseButton
                  padding={'0px'}
                  fontSize={'15px'}
                  color={'#436175'}
                  onClick={() => handleRemoveTag(chip?.fieldName, chip.fieldValue)}
                />
              </Tag>
          }
          )}
        </Box>
        <Box className='right-inner-clips-box'>
          {(chipsValue.length > 0 || (transferFilterModel?.createdAt?.dateFrom && transferFilterModel?.createdAt?.dateTo)) &&
            <button
              className="clear-all-btn"
              onClick={() => clearAllFilters()}
            >
              Clear All
            </button>
          }
        </Box>
      </Box>
      <QueueGrid
        gridRef={gridRef}
        isSuperAdmin={isSuperAdmin}
        cognitoGroup={cognitoGroup}
        isStoreAdmin={isStoreAdmin}
        isStoreAgent={isStoreAgent}
        // transferType={!isOutbound}
        transferType={true}
      />
    </Box>
  ) : (
    <></>
  );
}
